import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap";
import {
  GET_ALL_SAVED_CARD_DETAILS,
  // TOKEN,
  BASEURL,
  // CUSTOMERID,
} from "../../CONSTANTS";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../Components/Loader";
import Cookies from "js-cookie";
import { useScreenSize, useCustomScreen } from "../../Components/Utils";
import { use } from "react";
import toast from "react-hot-toast";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function UploadImage() {
  return (
    <Container className="pb-5">
      <div>
        {/* <Form noValidate validated={validated} onSubmit={handleSubmit}> */}
        <div>
          <Row as={Row} controlId="formFile" className="mb-3">
            <h5>
              <b>Upload Logo</b>
            </h5>
            <label column sm={2} className="contact-upload-label">
              Upload:
            </label>
            <Col sm={5} className="organization-name">
              <input className="form-control" type="file" />
            </Col>
            <Col sm={2}>
              <img
                src="/images/default_logo.png"
                className="Organization-logo"
                alt="logo"
              />
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export function ContactInformationForm() {
  const navigate = useNavigate();
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const states = [
    "Alabama",
    "Alaska",
    "Alberta",
    "Arizona",
    "Arkansas",
    "British Columbia",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Labrador",
    "Louisiana",
    "Maine",
    "Manitoba",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Brunswick",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "Newfoundland",
    "North Carolina",
    "North Dakota",
    "North West Terr.",
    "Nova Scotia",
    "Nunavut",
    "Ohio",
    "Oklahoma",
    "Ontario",
    "Oregon",
    "Pennsylvania",
    "Prince Edward Is.",
    "Quebec",
    "Rhode Island",
    "Saskatchewan",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
    "Yukon",
    "New South Wales",
    "Victoria",
    "Queensland",
    "Western Australia",
    "South Australia",
    "Tasmania",
    "Northern Territory",
    "Australian Capital Territory"
  ];
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    phone1: "",
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    state: "",
    zipCode: "",
  });
  const [errors, setErrors] = useState({});
  const CUSTOMERID =
    window.localStorage.getItem("customerId") ||
    JSON.parse(Cookies.get("decodedToken")).customerid;
  const TOKEN = window.localStorage.getItem("token") || Cookies.get("token");

  useEffect(() => {
    getUserData();
  }, []);

  const getUserInfo = async () => {
    try {
      const res = await fetch(GET_ALL_SAVED_CARD_DETAILS, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your token here
        },
      });
      if (res.ok) {
        let result = await res.json();
        if (result) {
          setUserDetails(result);
        }
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    }
  };

  const getUserData = async () => {
    try {
      const response = await fetch(`${BASEURL}customers/${CUSTOMERID}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      const data = await response.json();
      const phoneDigits = data.phone1?.replace(/\D/g, "");
      const formattedPhone =
  data.zipCode?.length === 4
    ? formatAUPhoneForDisplay(phoneDigits)
    : formatUSPhoneForDisplay(phoneDigits);
     

      setUserDetails({
        ...data,
        phone1: formattedPhone,
      });
    } catch (e) {
      console.log("error", e);
    }
  };

  const validateField = (name, value) => {
    let error = "";

    const stringFields = ["FirstName", "LastName", "City"];

    if (stringFields.includes(name)) {
      if (!/^[A-Za-z\s]*$/.test(value)) {
        error = `${
          name.charAt(0).toUpperCase() + name.slice(1)
        } should contain only letters`;
      }
    }

    if (name === "CompanyName") {
      if (!value.trim()) {
        error = "Company Name is required";
      }
    }

//    if (name === "Zip") {
//   const cleaned = value.replace(/[^0-9A-Za-z]/g, "");
//   const digitsOnly = cleaned.replace(/[^0-9]/g, "");
//   const containsLetter = /[A-Za-z]/.test(cleaned);

//   if (containsLetter) {
//     if (!/^[A-Za-z0-9]{5,6}$/.test(cleaned)) {
//       error = "Postal code must be 5–6 alphanumeric characters";
//     }
//   } else {
//     if (!/^\d{0,5}$/.test(digitsOnly)) {
//       error = "Zip must be up to 5 digits";
//     }
//   }
// }


if (name === "Zip") {
  const cleaned = value.replace(/[^0-9A-Za-z]/g, "");
  const digitsOnly = cleaned.replace(/[^0-9]/g, "");
  const containsLetter = /[A-Za-z]/.test(cleaned);

  // 🇦🇺 AU → 4 digits
  if (!containsLetter && digitsOnly.length <= 4) {
    value = digitsOnly.slice(0, 4);
    if (!/^\d{0,4}$/.test(value)) {
      error = "Australian postcode must be 4 digits";
    }
  }

  // 🇨🇦 Canada → alphanumeric 5–6
  else if (containsLetter) {
    value = cleaned.slice(0, 6).toUpperCase();
    if (cleaned.length < 5 || cleaned.length > 6) {
      error = "Canadian postal code must be 5–6 alphanumeric characters";
    }
  }

  // 🇺🇸 US → 5 digits
  else {
    value = digitsOnly.slice(0, 5);
    if (!/^\d{0,5}$/.test(value)) {
      error = "ZIP must be up to 5 digits";
    }
  }
}


    // if (name === "Phone") {
    //   const digitsOnly = value.replace(/\D/g, "");
    //   const usPattern = /^(\+1\s?)?(\d{3})[\s-]?(\d{3})[\s-]?(\d{4})$/;
      
    //   const formattedPattern = /^\(\d{3}\) \d{3}-\d{4}$/;

    //   if (value.startsWith("+1")) {
    //     if (!usPattern.test(value)) {
    //       error = "Invalid phone number format";
    //     }
    //   } else {
    //     if (!formattedPattern.test(value) && !usPattern.test(value)) {
    //       error = "Phone must be a valid US number format";
    //     }
    //   }

    //   if (digitsOnly.length < 10 || digitsOnly.length > 11) {
    //     error = "Phone number must be 10 or 11 digits";
    //   }
    // }
if (name === "Phone") {
  const digitsOnly = value.replace(/\D/g, "");

  if (userDetails.zipCode?.length === 4) {
    // AU validation
    if (digitsOnly.length !== 10 ) {
      error = "Australian mobile must be 10 digits";
    }
  } else {
    // US/CA validation
    if (digitsOnly.length !== 10) {
      error = "Phone number must be 10 digits";
    }
  }
}

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  // const handleChange = (field) => (e) => {
  //   let { name, value } = e.target;

  //   if (name === "Phone") {
  //     let input = value.replace(/[^\d+]/g, "");
  //     if (!input.startsWith("+")) {
  //       input = input.replace(/\D/g, "");
  //       if (input.length <= 10) {
  //         let formatted = "";
  //         if (input.length > 0) formatted += "(" + input.substring(0, 3);
  //         if (input.length >= 4) formatted += ") " + input.substring(3, 6);
  //         if (input.length >= 7) formatted += "-" + input.substring(6, 10);
  //         value = formatted;
  //       } else {
  //         value = input;
  //       }
  //     } else {
  //       value = input;
  //     }
  //   }

  //   if(name === "zipCode"){
      
  //   }

  //   setUserDetails((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));

  //   validateField(name, value);
  // };


const handleChange = (field) => (e) => {
  let { name, value } = e.target;
  let error = "";

//  if (name === "Phone") {
//   const digitsOnly = value.replace(/\D/g, "");

//   // 🇦🇺 AU mobile if ZIP length === 4
//   if (userDetails.zipCode?.length === 4) {
//     value = formatAUPhoneForDisplay(digitsOnly);
//   }
//   // 🇺🇸 / 🇨🇦 US & CA
//   else {
//     value = formatUSPhoneForDisplay(digitsOnly);
//   }
// }

if (name === "Phone") {
  let digitsOnly = value.replace(/\D/g, "");

  // 🇦🇺 AU → 10 digits max → 12 chars formatted
  if (userDetails.zipCode?.length === 4) {
    digitsOnly = digitsOnly.slice(0, 10);
    value = formatAUPhoneForDisplay(digitsOnly);
  }
  // 🇺🇸 / 🇨🇦 US & CA → 10 digits max → 14 chars formatted
  else {
    digitsOnly = digitsOnly.slice(0, 10);
    value = formatUSPhoneForDisplay(digitsOnly);
  }
}

  if (name === "Zip") {
    const cleaned = value.replace(/[^0-9A-Za-z]/g, "");
    const digitsOnly = cleaned.replace(/[^0-9]/g, "");
    const containsLetter = /[A-Za-z]/.test(cleaned);

    if (containsLetter) {
      value = cleaned.slice(0, 6).toUpperCase();
      if (cleaned.length < 5 || cleaned.length > 6) {
        error = "Canadian postal code must be 5–6 alphanumeric characters";
      }
    } else {
      value = digitsOnly.slice(0, 5);
      if (!/^\d{0,5}$/.test(value)) {
        error = "ZIP must be up to 5 digits";
      }
    }
  }

 
  setUserDetails((prev) => ({
    ...prev,
    [field]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: error,
  }));

  validateField(name, value);
};


  // const formatPhoneForDisplay = (phone) => {
  //   if (!phone) return "";
  //   const digitsOnly = phone.replace(/\D/g, "");

  //   let number = digitsOnly;
  //   if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
  //     number = digitsOnly.substring(1);
  //   }

  //   if (number.length !== 10) return phone;

  //   return `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6)}`;
  // };

  // const formatPhoneForDisplay = (phone) => {
  //   if (!phone) return "";

  //   // Remove all non-digit characters
  //   const digitsOnly = phone.replace(/\D/g, "");

  //   // Limit to 15 digits max
  //   const number = digitsOnly.slice(0, 18);

  //   // If fewer than 10 digits, return as-is
  //   if (number.length < 10) return number;

  //   const area = number.slice(0, 3);
  //   const middle = number.slice(3, 6);
  //   const last = number.slice(6, 10);
  //   const extra = number.slice(10); // anything after 10 digits

  //   return `(${area}) ${middle}-${last}${extra}`;
  // };

  const formatPhoneForPayload = (phone) => {
    let cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 10) {
      cleaned = cleaned;
    }
    return cleaned;
  };

//   const formatAUPhoneForDisplay = (digits) => {
//   if (!digits) return "";
//   const cleaned = digits.replace(/\D/g, "").slice(0, 10);

//   let formatted = "";
//   if (cleaned.length > 0) formatted += cleaned.substring(0, 4);
//   if (cleaned.length >= 5) formatted += " " + cleaned.substring(4, 7);
//   if (cleaned.length >= 8) formatted += " " + cleaned.substring(7, 10);

//   return formatted;
// };

const formatAUPhoneForDisplay = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 4) return digits;
  if (digits.length <= 7)
    return `${digits.slice(0, 4)} ${digits.slice(4)}`;

  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
};


// const formatUSPhoneForDisplay = (digits) => {
//   const cleaned = digits.replace(/\D/g, "").slice(0, 10);
//   if (cleaned.length < 10) return cleaned;

//   return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
// };

const formatUSPhoneForDisplay = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length < 4) return digits;
  if (digits.length < 7)
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};


const getPhoneMaxLength = (country) => {
  if (country === "AU") return 12;
  if (country === "US" || country === "CA") return 14;
  return 14;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, companyName, phone1, streetAddress1 } =
      userDetails;
    const phone = formatPhoneForPayload(phone1);
    const updatedFullName = [userDetails.firstName, userDetails.lastName]
  .filter(Boolean) 
  .join(" ");
    const updatedUserDetails = {
      ...userDetails,
      phone1: phone,
      fullName: updatedFullName
    };
    if (
      errors.FirstName ||
      errors.LastName ||
      errors.CompanyName ||
      errors.Phone ||
      errors.City ||
      errors.Zip
    ) {
      toast.error("Please enter valid details", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
      return;
    }
    try {
      setLoading(true);
      const resposne = await fetch(`${BASEURL}customers/${CUSTOMERID}`, {
        method: "PUT",
        body: JSON.stringify(updatedUserDetails),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      const data = await resposne.text();
      
      if (resposne.ok) {

       window.location.reload();
       
        toast.success("Profile Information updated successfully..!", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                color: "green",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleCheck}
            />
          ),
          style: {
            backgroundColor: "#E7EFC7",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } else {
        toast.error("Failed to update", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      }
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className=" paswd-contnr credits-purchase">
      <div>
        <h5
          className="text-md-start text-center"
          style={{
            fontSize: is4kScreen ? "1.7rem" : isIpadProPortrait ? "1.7rem" : "",
          }}
        >
          <b>Contact Information</b>
        </h5>
        <div className="p-sm-4 ">
          <Row className="mb-3" controlId="name">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                First Name:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                value={userDetails?.firstName}
                name="FirstName"
                onChange={handleChange("firstName")}
                type="text"
                required
                disabled={loading}
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.FirstName && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.FirstName}
                </span>
              )}
            </Col>
          </Row>
          <Row className="mb-3" controlId="name">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Last Name:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                type="text"
                name="LastName"
                disabled={loading}
                value={userDetails?.lastName}
                onChange={handleChange("lastName")}
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.LastName && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.LastName}
                </span>
              )}
            </Col>
          </Row>
          <Row className="mb-3" controlId="company">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Company Name:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                type="text"
                name="CompanyName"
                disabled={loading}
                value={userDetails?.companyName}
                onChange={handleChange("companyName")}
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.CompanyName && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.companyName}
                </span>
              )}
            </Col>
          </Row>
          <Row className="mb-3" controlId="phone_number">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Phone Number:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                type="text"
                name="Phone"
                disabled={loading}
                value={userDetails?.phone1}
                onChange={handleChange("phone1")}
                maxLength={14}
                required
                min={0}
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.Phone && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.Phone}
                </span>
              )}
            </Col>
          </Row>
          <Row className="mb-3" controlId="address_line_1">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Address Line 1:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                disabled={loading}
                value={userDetails?.streetAddress1}
                onChange={handleChange("streetAddress1")}
                type="text"
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
            </Col>
          </Row>
          <Row className="mb-3" controlId="address_line_1">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Address Line 2:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                disabled={loading}
                value={userDetails?.streetAddress2}
                onChange={handleChange("streetAddress2")}
                type="text"
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
            </Col>
          </Row>
          <Row className="mb-3" controlId="city">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Suburb/City:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                disabled={loading}
                type="text"
                name="City"
                value={userDetails?.city}
                onChange={handleChange("city")}
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.City && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.City}
                </span>
              )}
            </Col>
          </Row>
          <Row className="mb-3" controlId="name">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                State/Province:
              </label>
            </Col>
            <Col sm={6}>
              <select
                className="form-select"
                disabled={loading}
                value={userDetails?.state}
                onChange={handleChange("state")}
                aria-label="Default select example"
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "",
                }}
                required
              >
                {/* <option>Visa</option> */}
                {states.map((city, ind) => {
                  return (
                    <option
                      value={city}
                      style={{
                        fontSize: isIpadProPortrait
                          ? "1rem"
                          : isMediumScreen
                          ? "1rem"
                          : "",
                      }}
                    >
                      {city}
                    </option>
                  );
                })}
                {/* <option value="Colorado">Colorado</option>
                <option value="Texas">Texas</option>
                <option value="California">California</option> */}
              </select>
            </Col>
          </Row>
          <Row className="mb-3" controlId="city">
            <Col sm={4}>
              <label
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                Zip/Postal Code:
              </label>
            </Col>
            <Col sm={6}>
              <input
                className="form-control"
                disabled={loading}
                name="Zip"
                value={userDetails?.zipCode}
                onChange={handleChange("zipCode")}
                type="text"
                required
                style={{
                  height: isIpadProPortrait ? "3rem" : "",
                  fontSize: isIpadProPortrait
                    ? "1.5rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              />
              {errors.Zip && (
                <span
                  style={{
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isMediumScreen
                      ? "1.13rem"
                      : "",
                  }}
                >
                  {errors.Zip}
                </span>
              )}
            </Col>
          </Row>
          <Row className="">
            <Col className="d-flex justify-content-center align-items-center">
              <Button
                className="login-btns btn mb-3"
                type="submit"
                // onClick={() => navigate("/signup")}
                onClick={handleSubmit}
                style={{
                  fontSize: is4kScreen
                    ? "1.7rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                }}
              >
                <Loader response={loading} action={"Save"} />
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default function ProfileInfo() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  return (
    <div className="p-3">
      <h5
        style={{
          backgroundColor: "lightblue",
          padding: "1em",
          fontSize: is4kScreen
            ? "2rem"
            : isXxlScreen
            ? "1.4rem"
            : isXlScreen
            ? "1.2rem"
            : isIpadProPortrait
            ? "1.95rem"
            : isLargeScreen
            ? ""
            : isMediumScreen
            ? "1.7rem"
            : "",
        }}
      >
        <b>Profile Information</b>
      </h5>
      {/* <UploadImage /> */}
      <hr />
      <ContactInformationForm />
    </div>
  );
}

// const firstNameChangeHandler=(e)=>{
//   let tempUser = userDetails;
//   if('firstName' in tempUser){
//     tempUser['firstName'] = e.target.value
//   }
//   setUserDetails({...tempUser})
// }
// const lastNameChangeHandler = (e)=>{
//   let tempUser = userDetails;
//   if('lastName' in tempUser){
//     tempUser['lastName'] = e.target.value;
//     setUserDetails({...tempUser})
//   }
// }
// const companyNameChangeHandler = (e)=>{
//   let tempUser = userDetails;
//   if('companyName' in tempUser){
//     tempUser['companyName'] = e.target.value;
//     setUserDetails({...tempUser})
//   }
// }
// const phoneChangeHandler = (e)=>{
//   let tempUser = userDetails;
//   if('phone1' in tempUser){
//     tempUser['phone1'] = e.target.value;
//     setUserDetails({...tempUser})
//   }
// }

// const address1ChangeHandler = (e)=>{
//   let tempUser = userDetails;
//   if('streetAddress1' in tempUser){
//     tempUser['streetAddress1'] = e.target.value;
//     setUserDetails({...tempUser})
//   }
// }

// const address2ChangeHandler = (e)=>{
//   let tempUser = userDetails;
//   if('streetAddress2' in tempUser){
//     tempUser['streetAddress2'] = e.target.value;
//     setUserDetails({...tempUser})
//   }
// }
